import PromoCodeNew from './PromoCodeNew'

export default PromoCodeNew
